import { HourglassIcon } from "../../icons";

const ProcessingStep = ({ centered = false }) => (
  <div
    className={`flex h-full min-h-0 flex-1 flex-col px-6 ${
      centered ? "items-center justify-center" : "pt-4"
    }`}
  >
    <div
      className={`flex flex-col items-center gap-6 ${
        centered ? "" : "flex-1 justify-center"
      }`}
    >
      <div className="relative flex items-center justify-center">
        <div className="absolute size-16 rounded-full bg-primary/10 animate-pulse" />

        <div className="animate-hourglass">
          <HourglassIcon />
        </div>
      </div>

      <div className="flex max-w-[337px] flex-col items-center gap-0 text-center">
        <p className="text-base font-semibold leading-7 text-text-primary">
          Processing
        </p>
        <p className="text-xs font-medium leading-[21px] text-text-secondary">
          please wait while we process your transaction. This will take no more
          than 30 seconds
        </p>
      </div>
    </div>
  </div>
);

export default ProcessingStep;
